(function () {
  let addEvent = (el, type, fn) => {
    if (el.addEventListener) {
      el.addEventListener(type, fn, false);
    } else {
      el.attachEvent('on' + type, fn);
    }
  };

  let extend = (obj, ext) => {
    for (var key in ext) {
      if (ext.hasOwnProperty(key)) {
        obj[key] = ext[key];
      }
    }

    return obj;
  };

  let toFit = document.querySelectorAll('.text-scale-with-container');
  toFit.forEach((parent) => {

    var settings = {
      minFontSize: -1 / 0,
      maxFontSize: 1 / 0,
    };

    let scaleRate = parent.getAttribute('to-scale');
    
    var compressor = scaleRate || 1;

    let resizeOnChange = () => {
      let maxFont  = parent.getAttribute('max-font') || settings.maxFontSize;

      let el = parent.querySelectorAll('ul li');
      let toFontSize = Math.max(Math.min(el[0].clientWidth / (compressor * 10), parseFloat(maxFont)), parseFloat(settings.minFontSize));

      parent.style.fontSize = toFontSize + 'px';
      if (!parent.classList.contains('--loaded')) {
        parent.classList.add('--loaded');
      }
    };

    addEvent(window, 'resize', resizeOnChange);
    addEvent(window, 'orientationchange', resizeOnChange);

    let overlayImage = parent.querySelector('.text-behind-image--content');
    if (overlayImage) {
      overlayImage.style.backgroundImage = 'url("' + overlayImage.getAttribute('image') + '")';
    }


    window.addEventListener('load', function() {
      resizeOnChange();
    });
  });
})();